/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateDraftApiArg, UpdateQuickDraftResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateDraft: build.mutation<UpdateQuickDraftResponse, UpdateDraftApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/quick-draft/${queryArg.id}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateDraftApi };
export const { useUpdateDraftMutation } = injectedRtkApi;
